import { React } from 'react';
import { Flex, Spinner } from '@chakra-ui/react';

function LoadingInterviews() {
  return (
    <Flex justifyContent='center' mt='300px'>
      <Spinner thickness='5px' speed='0.65s' emptyColor='gray.200' color='blue.500' size='xl' />
    </Flex>
  );
}

export default LoadingInterviews;
